import Vue from 'vue'
import ElementUI from 'element-ui'
import * as VueGoogleMaps from 'vue2-google-maps'
import locale from 'element-ui/lib/locale/lang/en'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.scss'
import StarRating from 'vue-star-rating'
import PhoneNumberInput from './components/Common/PhoneNumberInput.vue'

import keys from '../keys'

import * as services from './providers/services'
import * as strings from './assets/strings'
import { directive as onClickOutside } from 'vue-on-click-outside'
Vue.directive('on-click-outside', onClickOutside)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

Vue.component('PhoneNumberInput', PhoneNumberInput)
Vue.component('star-rating', StarRating)

if (process.env.VUE_APP_API_TARGET === 'production') {
  console.log = () => {}
}
console.log('process.env.VUE_APP_API_TARGET', process.env.VUE_APP_API_TARGET)

Vue.prototype.$_services = services
Vue.prototype.$_strings = strings

Vue.use(VueGoogleMaps, {
  load: {
    key: keys().googleMapsApiKey
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
